import React from 'react'
// @src imports
import { ProfileAvatar } from 'src/chrome'
import { FlexColumn, SponsorName } from 'src/styled'
import { getMarketingContent, MinimalSponsorFragment } from 'src/graphql'
import { Spacer, Text } from '@sendoutcards/quantum-design-ui'
import { useQueries, useSelector } from 'src/hooks'

const container: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'right',
  alignItems: 'left',
  padding: '5px 0',
}
const avatar: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'left',
  marginRight: 10,
  alignItems: 'baseline',
  color: '#FFF',
  fontWeight: 'bold',
}

interface SponsorCardProps {
  sponsor: MinimalSponsorFragment
}

const SponsorCard: React.FC<SponsorCardProps> = props => {
  const { sponsor } = props
  const { isMobile } = useSelector(s => s.window)

  const [{ sharingInformationCopy }] = useQueries(getMarketingContent())
  return (
    <>
      <FlexColumn
        style={{
          width: '100%',
        }}
      >
        <div style={container}>
          <Text type="body" color="primaryHeading">
            I was referred by
          </Text>
          <ProfileAvatar
            avatarWrapperStyles={{
              width: 'initial',
              alignItems: 'baseline',
            }}
            style={avatar}
            image={sponsor.storefront?.mugshot?.url ?? ''}
            name={`${sponsor.firstName} ${sponsor.lastName}`}
            size={50}
          />
          <SponsorName id={'sponsor_name'}>
            <Text type="caption" color="primaryHeading">
              {`${sponsor.firstName} ${sponsor.lastName}`}
            </Text>
          </SponsorName>
          <Spacer space="x2" />
          <Text type={isMobile ? 'caption' : 'body'} color="primaryHeading">
            {sharingInformationCopy.content}
          </Text>
          <Spacer space="x2" />
        </div>
        <Spacer space="x1" />
      </FlexColumn>
    </>
  )
}

export default SponsorCard
